import { Input as RefInput, InputProps } from 'antd';
import { InputNumber as RefInputNumber, InputNumberProps } from 'antd';

export type { InputProps, InputNumberProps };
export const Input = RefInput;
export const InputNumber = RefInputNumber;
